import Vue from "vue";
import axios from 'axios'
import VueAxios from 'vue-axios'
import App from "./App.vue";
import {store} from "./store/store.js";
import Vue2TouchEvents from "vue2-touch-events";
import VueConfetti from 'vue-confetti'
import Notifications from 'vue-notification'
import CanvasVideo from 'vue-canvasvideo'
import 'vue-canvasvideo/dist/vuecanvasvideo.min.css'

import VueConfirmDialog from 'vue-confirm-dialog'

Vue.use(VueConfirmDialog)
Vue.component('vue-confirm-dialog', VueConfirmDialog.default)

// import VueSimpleAlert from "vue-simple-alert";
//
// Vue.use(VueSimpleAlert);
Vue.use(CanvasVideo)
Vue.use(Notifications);

Vue.use(VueConfetti);
Vue.config.productionTip = false;

Vue.use(Vue2TouchEvents);
Vue.use(VueAxios, axios)
Vue.prototype.$appName = "Tuni Trivia";
//axios.defaults.headers.common['X-Frame-Options'] = 'ALLOWALL'
new Vue({
  store,
  render: h => h(App)
}).$mount("#app");
